import React from 'react';
import MovieCard from './MovieCard';
import { FaFilm } from 'react-icons/fa';

const MovieList = ({ movies, onSelectMovie, favorites, onToggleFavorite, searchPerformed }) => {
  if (!movies.length) {
    if (searchPerformed) {
      return (
        <div className="empty-state">
          <div className="empty-icon"><FaFilm /></div>
          <div className="empty-title">No results found</div>
          <div className="empty-text">Try a different search term or adjust your filters</div>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="movie-grid">
      {movies.map((movie) => (
        <MovieCard
          key={movie.imdbID}
          movie={movie}
          onClick={onSelectMovie}
          isFavorite={favorites.some(fav => fav.imdbID === movie.imdbID)}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
};

export default MovieList;
